import {useAppointmentStore, useOfferStore} from "../stores/appointment";

export default {
    props: {
        requestOffer: {
            type: Boolean,
            required: true
        }
    },

    computed: {
        appointmentStore() {
            return this.requestOffer ? useOfferStore() : useAppointmentStore()
        },
    }
}